import { useDesignSystem } from "./useDesignSystem";

export const useDesignTokens = () => {
  const ds = useDesignSystem();

  const colors = {
    primary: {
      main: ds?.colors?.primary?.main,
      text: ds?.colors?.primary?.contrastText,
      light: ds?.colors?.primary?.light,
      dark: ds?.colors?.primary?.dark,
      bg: ds?.colors?.primary?.bg,
    },
    secondary: {
      main: ds?.colors?.secondary?.main,
      text: ds?.colors?.secondary?.contrastText,
      light: ds?.colors?.secondary?.light,
      dark: ds?.colors?.secondary?.dark,
      bg: ds?.colors?.secondary?.bg,
    },
    error: {
      main: ds?.colors?.error?.main,
      text: ds?.colors?.error?.contrastText,
      light: ds?.colors?.error?.light,
      dark: ds?.colors?.error?.dark,
      bg: ds?.colors?.error?.bg,
    },
    success: {
      main: ds?.colors?.success?.main,
      text: ds?.colors?.success?.contrastText,
      light: ds?.colors?.success?.light,
      dark: ds?.colors?.success?.dark,
      bg: ds?.colors?.success?.bg,
    },
    info: {
      main: ds?.colors?.info?.main,
      text: ds?.colors?.info?.contrastText,
      light: ds?.colors?.info?.light,
      dark: ds?.colors?.info?.dark,
      bg: ds?.colors?.info?.bg,
    },
    disabled: {
      main: ds?.colors?.disabled?.main,
      text: ds?.colors?.disabled?.contrastText,
      light: ds?.colors?.disabled?.light,
      dark: ds?.colors?.disabled?.dark,
      bg: ds?.colors?.disabled?.bg,
    },
    ghost: {
      main: ds?.colors?.ghost?.main,
      text: ds?.colors?.ghost?.contrastText,
      light: ds?.colors?.ghost?.light,
      dark: ds?.colors?.ghost?.dark,
      bgTransparent: ds?.colors?.ghost?.bg,
    },
  };

  const font = {
    family: ds?.font?.fontFamily,
    baseSize: ds?.font?.fontSize,
    size: ds?.font?.fontSz,
    weight: ds?.font?.fontW,
  };

  const radius = {
    default: ds?.radius?.default,
    fpx: ds?.radius?.borderRd4px,
    epx: ds?.radius?.borderRd8px,
    spx: ds?.radius?.borderRd16px,
  };

  const border = {
    default: ds?.borderSz?.default,
    onePx: ds?.borderSz?.border1px,
    twoPx: ds?.borderSz?.border2px,
  };

  return {
    colors,
    font,
    radius,
    border,
    raw: ds, // optional escape hatch
  };
};
